export default {
  database: {
    tableName: "Nom de la table",
    actions: "Actions",
    noData: "Aucune donnée disponible",
    viewTable: "Consulter la table {table}",
    import: {
      importFileTitle: "Importer des données dans la table",
      chooseFile: "Importer un fichier",
      filePreview: "Contenu du fichier (aperçu des 5 premières lignes) :",
    },
    table: {
      typeineligibility: {
        table: "Type d'inéligibilé",
        columns: {
          email: "Email",
        }
      },
      planpayment: {
        table: "Plan de payment",
        columns: {
          totalAmount: "totalAmount",
          paymentAmount: "paymentAmount",
          paymentInitial: "paymentInitial",
          loanTermMonths: "loanTermMonths",
          description: "description",
          forForm: "Pour Formulaire"
        }
      },
      typemeter: {
        table: "Type de compteur",
        columns: {
          meterPhase: "type",
          cost: "Coût",
          calibration: "Calibrage",
          forForm: "Pour Formulaire"
        }
      },
      user: {
        table: "Utilisateur",
        columns: {
          email: "Email",
          emailVerifiedAt: "Email vérifié le",
          name: "Nom",
          firstname: "Prénom",
          currProject: "Projet actuel",
          lastLogin: "Dernière connexion"
        }
      },
      companiework: {
        table: "Entreprise de travaux",
        columns: {
          name: "Nom"
        }
      },
      enquete: {
        table: "Enquête",
        columns: {
          answers: "Réponses",
          createdAt: "Créé le",
          updatedAt: "Mis à jour le",
          uuid: "UUID",
          dispatchedAt: "Envoyé le",
          lastUpdatedAt: "Dernière mise à jour",
          synchronisedAt: "Synchronisé le",
          location: "Localisation",
          isDispatch: "Envoyé"
        }
      },
      project: {
        table: "Projet",
        columns: {
          name: "Nom",
          description: "Description",
          meterPriceRural2Wires: "Prix Rural 2 fils",
          meterPriceRural4Wires: "Prix Rural 4 fils",
          meterPriceUrban2Wires: "Prix Urbain 2 fils",
          meterPriceUrban4Wires: "Prix Urbain 4 fils",
          eligibilityRadius: "Rayon d'éligibilité",
          allowedEntities: "Entités autorisées"
        }
      },
      villagesneighborhood: {
        table: "Village / Arrondissement",
        columns: {
          villageDistrict: "District",
          arrondissement: "Arrondissement",
          commune: "Commune",
          geographicalArea: "Zone géographique",
          tvxCollectionZone: "Zone de collecte TVX"
        }
      },
      form: {
        table: "Formulaire",
        columns: {
          name: "Nom",
          form: "Formulaire",
          status: "Statut",
          createdAt: "Créé le",
          updatedAt: "Mis à jour le",
          description: "Description",
          tag: "Tag",
          isValid: "Valide",
          configDispatch: "Configuration Dispatch"
        }
      },
      customer: {
        table: "Client",
        columns: {
          name: "Nom",
          firstname: "Prénom",
          socialReason: "Raison sociale",
          signatureName: "Nom de la signature",
          signatureLink: "Lien de la signature",
          createdAt: "Créé le",
          updatedAt: "Mis à jour le",
          isActive: "Actif",
          isSold: "Soldé",
          dateSold: "Date de vente",
          telephone1: "Téléphone 1",
          telephone2: "Téléphone 2",
          amountPaid: "Montant payé",
          isValidated: "Validé"
        }
      },
      chargelayer: {
        table: "Couche de charge",
        columns: {
          name: "Nom"
        }
      },
      village: {
        table: "Village",
        columns: {
          name: "Nom",
          societe: "Société"
        }
      },
      placemeter: {
        table: "Compteur de places",
        columns: {
          uuidONA: "UUID ONA",
          socialReason: "Raison sociale",
          nameEnqueteur: "Nom de l'enquêteur",
          dateSurvey: "Date de l'enquête",
          updatedAt: "Mis à jour le",
          longitude: "Longitude",
          latitude: "Latitude",
          typeSubscriber: "Type d'abonné",
          typeInfraAGR: "Type d'infrastructure AGR",
          detailTypeInfraAGR: "Détail type infrastructure AGR",
          moreTypeInfraAGR: "Autre type infrastructure AGR",
          systElectDispo: "Système électrique disponible",
          heavyEquipAvailable: "Équipements lourds disponibles",
          nbMeters2filsWished: "Nombre de compteurs 2 fils souhaités",
          nbMeters4filsWished: "Nombre de compteurs 4 fils souhaités",
          typeCircuitBreakerWished: "Type de disjoncteur souhaité",
          comment: "Commentaire",
          nameEntrepriseTvx: "Nom de l'entreprise TVX",
          amountPaid: "Montant payé",
          isEligible: "Éligible",
          isSold: "Soldé"
        }
      },
      layerdata: {
        table: "Données de couche",
        columns: {
          properties: "Propriétés",
          geom: "Géométrie"
        }
      },
      chargepoint: {
        table: "Point de charge",
        columns: {
          type: "Type",
          description: "Description",
          latitude: "Latitude",
          longitude: "Longitude"
        }
      },
      servicerepartition: {
        table: "Répartition service",
        columns: {
          voltage: "Tension",
          mismatchfactor: "Facteur de déséquilibre",
          codStudyarea: "Code zone d'étude",
          codService: "Code service"
        }
      },
      infrastructurerepartition: {
        table: "Répartition infrastructure",
        columns: {
          voltage: "Tension",
          codStudyarea: "Code zone d'étude",
          codInfrastructure: "Code infrastructure",
          mismatchFactor: "Facteur de déséquilibre"
        }
      },
      infrastructurehourly: {
        table: "Infrastructure horaire",
        columns: {
          codInfrastructure: "Code infrastructure",
          codStudyarea: "Code zone d'étude",
          codScenario: "Code scénario",
          hour01: "Heure 01",
          hour02: "Heure 02",
          hour03: "Heure 03",
          hour04: "Heure 04",
          hour05: "Heure 05",
          hour06: "Heure 06",
          hour07: "Heure 07",
          hour08: "Heure 08",
          hour09: "Heure 09",
          hour10: "Heure 10",
          hour11: "Heure 11",
          hour12: "Heure 12",
          hour13: "Heure 13",
          hour14: "Heure 14",
          hour15: "Heure 15",
          hour16: "Heure 16",
          hour17: "Heure 17",
          hour18: "Heure 18",
          hour19: "Heure 19",
          hour20: "Heure 20",
          hour21: "Heure 21",
          hour22: "Heure 22",
          hour23: "Heure 23",
          hour24: "Heure 24"
        }
      },
      scenario: {
        table: "Scénario",
        columns: {
          name: "Nom",
          duration: "Durée",
          codScenario: "Code scénario"
        }
      },
      study: {
        table: "Étude",
        columns: {
          name: "Nom",
          codStudy: "Code étude"
        }
      },
      specificdemandhourly: {
        table: "Demande spécifique horaire",
        columns: {
          codScenario: "Code scénario",
          codSpecificdemand: "Code demande spécifique",
          hour01: "Heure 01",
          hour02: "Heure 02",
          hour03: "Heure 03",
          hour04: "Heure 04",
          hour05: "Heure 05",
          hour06: "Heure 06",
          hour07: "Heure 07",
          hour08: "Heure 08",
          hour09: "Heure 09",
          hour10: "Heure 10",
          hour11: "Heure 11",
          hour12: "Heure 12",
          hour13: "Heure 13",
          hour14: "Heure 14",
          hour15: "Heure 15",
          hour16: "Heure 16",
          hour17: "Heure 17",
          hour18: "Heure 18",
          hour19: "Heure 19",
          hour20: "Heure 20",
          hour21: "Heure 21",
          hour22: "Heure 22",
          hour23: "Heure 23",
          hour24: "Heure 24"
        }
      },
      appliancerepartition: {
        table: "Répartition des appareils",
        columns: {
          codStudyarea: "Code zone d'étude",
          codAppliance: "Code appareil"
        }
      },
      specificdemand: {
        table: "Demande spécifique",
        columns: {
          codSpecificDemand: "Code demande spécifique",
          name: "Nom",
          voltage: "Tension",
          numSeason: "Numéro de saison",
          mismacthFactor: "Facteur de déséquilibre",
          creationYear: "Année de création"
        }
      },
      seuil: {
        table: "Seuils",
        columns: {
          label: "Libellé",
          value: "Valeur"
        }
      },

      householdthreshold: {
        table: "Seuils ménages",
        columns: {
          label: "Libellé",
          value: "Valeur"
        }
      },

      servicehourly: {
        table: "Service horaire",
        columns: {
          codStudyarea: "Code zone d'étude",
          codScenario: "Code scénario",
          codService: "Code service",
          hour01: "Heure 01",
          hour02: "Heure 02",
          hour03: "Heure 03",
          hour04: "Heure 04",
          hour05: "Heure 05",
          hour06: "Heure 06",
          hour07: "Heure 07",
          hour08: "Heure 08",
          hour09: "Heure 09",
          hour10: "Heure 10",
          hour11: "Heure 11",
          hour12: "Heure 12",
          hour13: "Heure 13",
          hour14: "Heure 14",
          hour15: "Heure 15",
          hour16: "Heure 16",
          hour17: "Heure 17",
          hour18: "Heure 18",
          hour19: "Heure 19",
          hour20: "Heure 20",
          hour21: "Heure 21",
          hour22: "Heure 22",
          hour23: "Heure 23",
          hour24: "Heure 24"
        }
      },
      equipment: {
        table: "Équipement",
        columns: {
          label: "Libellé",
          code: "Code",
          type: "Type"
        }
      },
      infrastructure: {
        table: "Infrastructure",
        columns: {
          name: "Nom",
          codInfrastructure: "Code infrastructure"
        }
      },
      appliancehourly: {
        table: "Appareil horaire",
        columns: {
          codHouseHold: "Code ménage",
          codScenario: "Code scénario",
          codStudyarea: "Code zone d'étude",
          codAppliance: "Code appareil",
          hour01: "Heure 01",
          hour02: "Heure 02",
          hour03: "Heure 03",
          hour04: "Heure 04",
          hour05: "Heure 05",
          hour06: "Heure 06",
          hour07: "Heure 07",
          hour08: "Heure 08",
          hour09: "Heure 09",
          hour10: "Heure 10",
          hour11: "Heure 11",
          hour12: "Heure 12",
          hour13: "Heure 13",
          hour14: "Heure 14",
          hour15: "Heure 15",
          hour16: "Heure 16",
          hour17: "Heure 17",
          hour18: "Heure 18",
          hour19: "Heure 19",
          hour20: "Heure 20",
          hour21: "Heure 21",
          hour22: "Heure 22",
          hour23: "Heure 23",
          hour24: "Heure 24"
        }
      },
      service: {
        table: "Service",
        columns: {
          name: "Nom",
          codService: "Code service"
        }
      },
      appliance: {
        table: "Appareil",
        columns: {
          name: "Nom",
          codAppliance: "Code appareil"
        }
      },
      consumertype: {
        table: "Type de consommateur",
        columns: {
          code: "Code",
          label: "Libellé",
          type: "Type"
        }
      },
      studyarea: {
        table: "Zone d'étude",
        columns: {
          name: "Nom",
          codStudyArea: "Code zone d'étude"
        }
      },
      meter: {
        table: "Compteur",
        columns: {
          typeMeter: "Type de compteur",
          numMeter: "Numéro de compteur",
          dateConnection: "Date de connexion",
          length2x16: "Longueur 2x16",
          length4x16: "Longueur 4x16",
          typeDisjoncteur: "Type de disjoncteur",
          numPoliceAbonnement: "Numéro police abonnement",
          dateAbonnement: "Date abonnement",
          settingDisjoncteur: "Réglage disjoncteur",
          dateMES: "Date MES"
        }
      }
    }
  }
};
